import React from 'react';

import { Divider } from 'antd';

import styled from 'styled-components';

import { NwLinkButton } from '@components/Gui/NwButton';

const SelectionBarWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;

    .ant-divider-vertical {
        margin: 0 0.5rem;
    }
`;

const SelectionBar = ({ actions = [], className = '' }) => {
    const visibleActions = actions.filter(Boolean);
    const wrapperClassName = ['selection-bar', className].filter(Boolean).join(' ');

    if (visibleActions.length === 0) {
        return null;
    }

    return (
        <SelectionBarWrapper className={wrapperClassName}>
            {visibleActions.map((action, index) => {
                const { key, label, method, onClick, ...buttonProps } = action;
                return (
                    <React.Fragment key={key || label}>
                        {index > 0 && <Divider type="vertical" />}
                        <NwLinkButton label={label} onClick={method || onClick} {...buttonProps} />
                    </React.Fragment>
                );
            })}
        </SelectionBarWrapper>
    );
};

export default SelectionBar;
